import styled from 'styled-components';

const GradientOverlay = styled.div`
    height: 100%;
    height: 100%;
    background: radial-gradient(rgba(7, 51, 82, 0.1) 5%,rgba(7, 51, 82, 0.9) 75% , #073352 90%);
`

export default GradientOverlay;